import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { usdtContract, pepeContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const ApprovePepe = () => {

  const [balance, setBalance] = useState(null)
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.pepe;
  const tokenAddress1 = Environment.chinaTomi;
  const contract = pepeContract(tokenAddress, web3);


  const approvePepe = useCallback(
    async () => {
      try {
        // Max uint256 value for unlimited approval
        const maxApproval = "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";

        let gasPrice = await web3.eth.getGasPrice();
        gasPrice = parseInt(gasPrice) + 5000000000;

        const gas = await contract.methods
          .approve(tokenAddress1, maxApproval)
          .estimateGas({ from: account });

        const details = await contract.methods
          .approve(tokenAddress1, maxApproval)
          .send({
            from: account,
            gas: gas,
            gasPrice,
          });

        return details;
      } catch (error) {
        throw error;
      }
    },
    [contract, account, web3]
  );

  return { approvePepe: approvePepe };
};
export default ApprovePepe;